import React from 'react'
import {VOSVerificationView} from './VOSVerificationView'
import {Link} from 'react-router-dom'
type Mode = 'confirm' | 'dispute'

/**
 * Standalone web page for VOS confirm or dispute.
 * Full-page layout (no app sidebar) with header and centered form.
 */
export const VOSVerificationPage: React.FC<{mode: Mode}> = ({mode}) => {
  return (
    <div className='min-vh-100 d-flex flex-column' style={{backgroundColor: 'var(--kt-body-bg, #f5f5f5)'}}>
      <header className='bg-white shadow-sm py-3'>
        <div className='container d-flex align-items-center'>
          <Link to='/dashboard'>
          <img alt='Logo' src={"/media/logos/Ad _Astra_Logo_Red_prod.png"} className='h-35px' />
          </Link>
        </div>
      </header>
      <main className='flex-grow-1 d-flex align-items-center justify-content-center py-5'>
        <div className='container'>
          <div className='row justify-content-center'>
            <div className='col-12 col-lg-8 col-xl-6'>
              <VOSVerificationView mode={mode} standalone />
            </div>
          </div>
        </div>
      </main>
      <footer className='py-3 text-center text-gray-500 small'>
        <div className='container'>VOS verification — sign to confirm or dispute the meeting summary.</div>
      </footer>
    </div>
  )
}
